<template>
<div>
  <div id="footer" class="acea-row row-middle" :class="beian ? 'hasBeian' : ''">
    <router-link
      :to="item.url"
      class="item"
      :class="{ on: item.url === $route.path }"
      v-for="(item, index) in footerList"
      :key="index"
    >
      <div
        class="iconfont"
        :class="item.icon1 + ' ' + (item.url === $route.path ? item.icon2 : '')"
      ></div>
      <div>{{ item.name }}</div>
    </router-link>
  </div>
  <div class="beian" v-if="beian"><a href="https://beian.miit.gov.cn/" target="_blank">{{ beian }}</a></div>
</div>
</template>
<style scoped>
.beian {
  font-size: 0.12rem;
  position: fixed;
  width: 100%;
  text-align: center;
  background-color: #fff;
  height: 0.2rem;
  bottom: 0;
  z-index: 999999999;
  line-height: 0.2rem;
}
#footer.hasBeian {
  bottom: 0.2rem;
}
</style>
<script>
export default {
  name: "Footer",
  props: {
    beian: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      footerList: [
        {
          name: "首页",
          icon1: "icon-shouye-xianxing",
          icon2: "icon-shouye",
          url: "/"
        },
        {
          name: "分类",
          icon1: "icon-yingyongchengxu-xianxing",
          icon2: "icon-yingyongchengxu",
          url: "/category"
        },
        {
          name: "购物车",
          icon1: "icon-caigou-xianxing",
          icon2: "icon-caigou",
          url: "/cart"
        },
        {
          name: "我的",
          icon1: "icon-yonghu-xianxing",
          icon2: "icon-yonghu",
          url: "/user"
        }
      ]
    };
  },
  methods: {}
};
</script>
